import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button, { ButtonType, ButtonTheme } from '../button/button';
import './helpButton.scss';
import { IconType } from '../icon/icon';

/**
 * Help button is a Button associate to popup paragraph with a help text.
 */
const HelpButton = (props) => {
  const {
    children,
  } = props;
  const [displayHelp, setDisplayHelp] = useState(false);

  const onClickButton = () => {
    setDisplayHelp(!displayHelp);
  };

  const onBlur = () => {
    setDisplayHelp(false);
  };

  return (
    <div className="d-inline position-relative">
      <Button
        type={ButtonType.BUTTON}
        theme={ButtonTheme.LIGH}
        icon={IconType.QUESTION}
        onClick={onClickButton}
        onBlur={onBlur}
        className="helpbutton"
      />
      <div className={`popover helpbutton__popover text-dark ${displayHelp ? 'popover helpbutton__popover--block' : ''}`}>
        <div className="popover-content pt-3 px-2">
          <p dangerouslySetInnerHTML={{ __html: children }} />
        </div>
      </div>
    </div>
  );
};

HelpButton.propTypes = {
  /**
   * Text to show inside popover.
   */
  children: PropTypes.node,
};

HelpButton.defaultProps = {
  children: null,
};

export default HelpButton;
